/**
 * 409 de POST /api/checkout/accept-legal-note/{lead} (monolito): la contratación
 * no se puede completar con los datos actuales (`POLICY_VERSION_NOT_SELLABLE`).
 * El cuerpo trae `message` en castellano para el cliente; mientras no se despliegue
 * el hotfix de gf puede llegar vacío (`[]`). Cualquier 409 cuenta, venga como venga.
 *
 * Antes el front lo trataba como un error cualquiera y navegaba a
 * /waitingvalidation («pendiente de validación»); al recargar, el estado del lead
 * (legalnote_pending) devolvía a /payment/4: bucle silencioso.
 */
export interface LegalNoteRejectionI {
  /** Texto del servidor, si trae uno apto para el cliente. */
  message: string | null;
}

// Un slug (POLICY_VERSION_NOT_SELLABLE, Conflict…) no es un texto para el cliente.
const SLUG = /^[A-Za-z0-9_.-]*$/;

export const legalNoteRejection = (error: unknown): LegalNoteRejectionI | null => {
  const { status, message } = (error ?? {}) as { status?: unknown; message?: unknown };
  if (409 !== Number(status)) return null;
  const text = "string" === typeof message ? message.trim() : "";
  return { message: "" === text || SLUG.test(text) ? null : text };
};

type TranslateFn = (key: string) => string;

const translateOr = (translate: TranslateFn, key: string, fallback: string): string => {
  const value = translate(key);
  return value === key || !value ? fallback : value;
};

// Claves pendientes en getlife/translations (docs/i18n-pending.md). El cuerpo por
// defecto dice lo mismo que el `message` del servidor.
export const LEGAL_NOTE_REJECTION_FALLBACKS = {
  title: "No hemos podido completar la contratación",
  message:
    "No hemos podido completar la contratación con los datos actuales. Nuestro equipo revisará tu solicitud y se pondrá en contacto contigo.",
  close: "Cerrar",
};

export const legalNoteRejectionTexts = (
  translate: TranslateFn,
  rejection: LegalNoteRejectionI
) => ({
  title: translateOr(translate, "informativeNote.notSellable.title", LEGAL_NOTE_REJECTION_FALLBACKS.title),
  message:
    rejection.message ??
    translateOr(translate, "informativeNote.notSellable.message", LEGAL_NOTE_REJECTION_FALLBACKS.message),
  close: translateOr(translate, "informativeNote.notSellable.close", LEGAL_NOTE_REJECTION_FALLBACKS.close),
});
